import { BASE_URL } from "@constants/api.constants";
import { uploadFile } from "@utils/upload.util";

export const getFileUploadInputs = () => [
  {
    type: "FILE_UPLOAD",
    label: "Select File",
    id: "file",
    name: "file_name",
    placeholder: "Select File",
    handleSelfUpload: uploadFile,
    filePrefix: BASE_URL + "app-source/files/",
    value: null,
    validations: [
      {
        type: "REQUIRED",
        message: "File is required !",
      },
    ],
  },
];
